/* eslint-disable */
// prettier-ignore

export const messages = {
  system_admin_sso_title: "Single Sign-On (SSO) Configurations",
  system_admin_sso_add: "Add SSO Configuration",
  system_admin_sso_update: "Update SSO Configuration",
  system_admin_sso_domain: "Domain",
  system_admin_sso_type: "Type",
  system_admin_sso_provider: "Provider",
  system_admin_sso_oauth_config: "OAuth Configuration",
  system_admin_sso_created_successfully: "SSO configuration created successfully",
  system_admin_sso_updated_successfully: "SSO configuration updated successfully",
  system_admin_sso_warning: "A <u>domain</u> can only have <i><u><b>one</b></u></i> active SSO configuration at a time. Activating a configuration will <i><u><b>deactivate</b></u></i> the currently active one.",
  system_admin_sso_do_you_really_want_to_activate_the_sso_config: "Do you really want to activate the SSO configuration?",
  system_admin_sso_do_you_really_want_to_deactivate_the_sso_config: "Do you really want to deactivate the SSO configuration?",
  system_admin_sso_login_url: "Login URL",
  system_admin_sso_client_id: "Client ID",
  system_admin_sso_client_secret: "Client Secret",
  system_admin_sso_auth_url: "Authorization URL",
  system_admin_sso_token_url: "Token URL",
  system_admin_sso_user_info_url: "User Info URL",
  system_admin_sso_entity_id: "Entity ID",
};
